/*
 * Copyright(c) 1995 - 2020 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */

import { Component, Input } from '@angular/core';

@Component({
    selector: 'common-box',
    template: `
    <div class="box {{size}}">
        <div class="innerBox"><ng-content></ng-content></div>
    </div>`
})
export class BoxComponent {
    @Input() size: 'half' | 'full' | 'one' = 'full';
}
